import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-additional-information',
    templateUrl: './additional-information.component.html',
    styleUrls: ['./additional-information.component.scss'],
    standalone: false
})
export class AdditionalInformationComponent {
  @Input() formGroup!: FormGroup;
}
